import { getContactoContabilidadById } from "api/Contacto.service"
import { useCuentaContableEmpresaVenta } from "api/CuentaContableEmpresa.hook"
import { useCuentaContableCuentaVenta } from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { InputSwitch } from "primereact/inputswitch"
import { useCallback, useEffect } from "react"
import { useTranslation } from "react-i18next"

const CuentaContableDocumentoSetting = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()

  const { getCuentaContablePorDefecto } = useCuentasContables()
  const { cuentasContablesEmpresas: listaDeCuentasBase } =
    useCuentaContableCuentaVenta()

  const {
    cuentasContablesEmpresas: listaDeCuentas,
    cuentasContablesEmpresasRefetch: refresListaDeCuentas,
  } = useCuentaContableEmpresaVenta()

  const initialPorDefectoCuentasVentas = getCuentaContablePorDefecto(
    CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA
  )
  const initialPorDefectoDocumento = listaDeCuentas?.find(
    (cuentaContableEmpresaBase) => {
      return cuentaContableEmpresaBase?.id === initialPorDefectoCuentasVentas
    }
  )

  const setCuentaContableLibrado = useCallback(async () => {
    const res = await getContactoContabilidadById(values?.librado?.id)
    res?.cuentaContableVentaId &&
      setFieldValue("cuentaContableId", res?.cuentaContableVentaId)
  }, [setFieldValue, values?.librado?.id])

  useEffect(() => {
    if (!values?.config?.cuentaContableMultiple && values?.librado?.id) {
      setCuentaContableLibrado()
    }
  }, [
    setCuentaContableLibrado,
    values?.config?.cuentaContableMultiple,
    values?.librado?.id,
  ])

  return (
    <div className='tw-flex tw-flex-col tw-w-full'>
      {!values?.config?.cuentaContableMultiple && (
        <div className='tw-flex tw-flex-col tw-w-full'>
          <p className='text-left'>
            {t("crear.facturaRec.accountingAccountLabel")}
          </p>
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={listaDeCuentas}
            inputIdName='cuentaContableId'
            dropdownValue={values.cuentaContableId}
            onChange={({ value }: { value: string }) => {
              setFieldValue("cuentaContableId", value)
            }}
            cuentaPorDefecto={initialPorDefectoDocumento}
            listaDeCuentasBase={listaDeCuentasBase}
            refreshFetchData={refresListaDeCuentas}
            withCreateCuenta
          />
        </div>
      )}
      <div className='tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-h-14'>
        <p className='tw-m-0'>
          {t("crear.facturaRec.accountingAccountLabelConcept")}
        </p>
        <InputSwitch
          checked={values.config.cuentaContableMultiple}
          onChange={() =>
            setFieldValue(
              "config.cuentaContableMultiple",
              !values.config.cuentaContableMultiple
            )
          }
        />
      </div>
    </div>
  )
}

export default CuentaContableDocumentoSetting
